import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoginUser, setAuthenticated } from '../../redux/UserSlice';
import { useNavigate } from 'react-router-dom';
import SignUp from '../SignUp/SignUp';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [switchAcc, setSwitchAcc] = useState(false);
  const [isError, SetIsError] = useState('');
  const [msLoading, setMsLoading] = useState(false);

  const { loading } = useSelector((state) => state.user);

  // Check for SSO error from Microsoft redirect
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('ssoError') === '1') {
      SetIsError('Microsoft login failed. Please try again or use email/password.');
      // Clean the URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    let userCredentials = { email, password };

    try {
      const response = await dispatch(LoginUser(userCredentials));

      if (response.payload && response.payload.token && response.payload.email) {
        setEmail('');
        setPassword('');
        dispatch(setAuthenticated());
        navigate('/');
      } else {
        SetIsError(response.payload.message);
      }
    } catch (error) {
      SetIsError('Error: ' + error.message);
    }
  };

  const handleMicrosoftLogin = () => {
    setMsLoading(true);
    SetIsError('');
    window.location.href = `${process.env.REACT_APP_API}/auth/microsoft`;
  };

  if (switchAcc) {
    return <SignUp setSwitchAcc={setSwitchAcc} />;
  }

  return (
    <div className="w-full max-w-sm bg-white rounded-lg shadow-lg p-8">
      <form onSubmit={handleLogin} className="space-y-6">
        <h2 className="text-2xl font-bold text-center mb-4">Log In</h2>

        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
          required
        />

        {isError && <p className="text-red-600 text-sm">{isError}</p>}

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-md font-semibold hover:bg-blue-700 transition"
          disabled={loading}
        >
          {loading ? 'loading...' : 'Login'}
        </button>

        {/* Divider */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-2 bg-white text-gray-500">Or continue with</span>
          </div>
        </div>

        {/* Microsoft Login Button */}
        <button
          type="button"
          onClick={handleMicrosoftLogin}
          disabled={msLoading}
          className="w-full h-11 rounded-md border border-gray-300 bg-white text-gray-700 font-semibold flex items-center justify-center gap-2 hover:bg-gray-50 transition cursor-pointer"
        >
          {msLoading ? (
            'Please wait...'
          ) : (
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 23 23">
                <rect x="1" y="1" width="10" height="10" fill="#f25022" />
                <rect x="12" y="1" width="10" height="10" fill="#7fba00" />
                <rect x="1" y="12" width="10" height="10" fill="#00a4ef" />
                <rect x="12" y="12" width="10" height="10" fill="#ffb900" />
              </svg>
              Continue with Microsoft
            </>
          )}
        </button>

        <p className="text-center text-gray-700">
          Don&apos;t have an Account?{' '}
          <button
            type="button"
            onClick={() => setSwitchAcc(true)}
            className="text-blue-600 hover:underline font-semibold"
          >
            Sign Up
          </button>
        </p>
      </form>
    </div>
  );
};

export default Login;
